/*
 * @Author: your name
 * @Date: 2020-11-15 23:27:30
 * @LastEditTime: 2020-11-24 20:35:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/api/cart.js
 */
/*
 * @Author: your name
 * @Date: 2020-11-15 23:27:30
 * @LastEditTime: 2020-11-18 14:59:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/api/cart.js
 */
import request from "@/utils/request";
// 购物车
export async function getCartList(params) {
  const url = `/api/front/order/cart/getCartList`;
  return request(url, { params });
}
// 批量修改购物车选中状态
export async function batchSelect(params) {
  const url = `/api/front/order/cart/batchSelect`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
// 批量删除购物车商品
export async function batchDelete(params) {
  const url = `/api/front/order/cart/batchDelete`;
  return request(url, {
    method: "DELETE",
    data: params
  });
}
// 批量删除购物车商品
export async function updateCart(params) {
  const url = `/api/front/order/cart/updateCart`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 结算预下单
export async function preCheckout(params) {
  const url = `/api/front/order/cart/preCheckout`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 结算预下单
export async function checkout(params) {
  const url = `/api/front/order/cart/checkout`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 校验实名认证
export async function checkIdentityIdcard(params) {
  const url = `/api/daemon/identity/checkIdentityIdcard`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 校验实名认证
export async function addTCart(params) {
  const url = `/api/front/order/cart/addTCart`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 校验实名认证
export async function mallretailspuChoice(params) {
  const url = `api/product/retailSpu/mallretailspuChoice/${params.spuId}`;
  return request(url);
}
